/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty, kebabCase } from 'lodash';
import Icons from '../layouts/Icons';
import Button from '../layouts/Button';
import BoxedContainer from '../layouts/BoxedContainer';
import ExploreBlockVideoBlock from './ExploreBlockVideoBlock';

export default function ExploreBlock({ data }) {
  const { title, subtitle, text, link, image, videoUrl, boxedWidth } = data;
  const [isModal, setIsModal] = useState(false);

  const handleClick = () => {
    setIsModal(!isModal);
  };
  React.useEffect(() => {
    if (isModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [isModal]);
  return (
    <>
      <section
        className={`relative 
        ${boxedWidth ? '' : `clip-right-top lg:-mt-20 -mt-[20px] z-10`} 
        `}
      >
        <div
          className={`${
            boxedWidth
              ? `lg:h-[883px] h-[500px] mx-auto px-0 3xl:px-0 w-full lg:w-[80%]
              relative xl:!max-w-[1570px] before:!inline before:content-['']
              before:absolute before:top-0 before:w-full before:h-full before:bg-black
              before:bg-opacity-50`
              : `lg:h-[1020px] h-[580px] before:!inline before:content-['']
              before:absolute before:top-0 before:w-full before:h-full before:bg-black
              before:bg-opacity-50`
          }`}
        >
          {image && (
            <LazyLoadImage src={image.url} alt={title} className="w-full h-full object-cover" />
          )}
          <div
            className={`absolute top-0 w-full h-full ${
              boxedWidth ? 'lg:py-[190px] py-[80px]' : 'lg:py-[304px] py-[120px] '
            }`}
          >
            <BoxedContainer className="h-full boxed">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.4 }}
                viewport={{ once: true }}
                className={`flex flex-col lg:gap-y-[51px] gap-y-[35px] h-full ${
                  boxedWidth ? `xl:pl-[200px] lg:p-[100px]` : `3xl:pl-[400px] lg:pl-[200px]`
                }`}
              >
                <div
                  className={`flex flex-col lg:gap-y-[35px] gap-y-[20px] ${
                    boxedWidth ? 'lg:max-w-[570px]' : 'max-w-[575px]'
                  }`}
                >
                  <button
                    type="button"
                    onClick={handleClick}
                    aria-label="watch video"
                    className="watch-video"
                  >
                    <Icons icon="youtube-icon" className="lg:w-20 w-[3rem] lg:h-20 h-[3rem]" />
                  </button>
                  <div className="flex flex-col lg:gap-y-[27px] gap-y-[18px]">
                    <h3
                      className="text-white font-roboto-condensed-bold lg:text-2xl md:text-[29px]
                      text-[35px] leading-[42px] flex flex-col w-fit uppercase
                      md:gap-y-0 gap-y-2"
                    >
                      <span dangerouslySetInnerHTML={{ __html: title }} />
                      <span className="bg-white text-red border border-bg-6 px-[8px] -ml-2">
                        {subtitle}
                      </span>
                    </h3>
                    {isEmpty(text) || (
                      <p
                        className="text-white font-roboto-regular lg:text-[16px] text-[15px]
                    lg:leading-[30px] leading-6 lg:block hidden"
                        dangerouslySetInnerHTML={{ __html: text }}
                      />
                    )}
                    {isEmpty(text) || (
                      <p
                        className="text-white font-roboto-regular lg:text-[16px] text-[15px]
                      lg:leading-[30px] leading-6 lg:hidden block"
                      >
                        {text.replace(/<\/?br\s*\/?>/gi, '')}
                      </p>
                    )}
                  </div>
                </div>
                {isEmpty(link) || (
                  <Button
                    clickHandler={handleClick}
                    ariaLabel={link.name}
                    label={link.name}
                    tagName={kebabCase(link.name)}
                    variant="primaryWhite"
                    text="w-[145px] px-[26px] whitespace-pre !font-sans-bold !text-bg-10 !bg-white
                    hover:!text-white hover:!bg-black"
                  />
                )}
              </motion.div>
            </BoxedContainer>
          </div>
        </div>
      </section>
      {isModal && <ExploreBlockVideoBlock data={videoUrl} onClick={handleClick} />}
    </>
  );
}
